import React, { ReactElement } from 'react';
import { Container, InnerContainer, Item, Squiggle, Ball, animationPath } from './AnimatedLogo.styled';
import { ComponentProps as Props } from './AnimatedLogo.types';

const AnimatedLogo: React.FC<Props> = ({
  size,
  fullPage,
  fullPageBackgroundColour,
  className,
}): ReactElement<Props> => {
  const animatedLogo = (
    <Item size={size}>
      <svg className={className} viewBox="0 0 223 136" fill="none">
        <path
          fill="#1CCBD7"
          // eslint-disable-next-line max-len
          d="M181.551 79.0445L134.864 32.304C132.529 29.9664 128.744 29.9664 126.413 32.304L79.7214 79.0445C78.6156 80.1516 77.9899 81.6424 77.9723 83.2082C77.9723 83.4464 77.7124 106.995 77.9679 129.649C77.9591 129.768 77.9591 129.891 77.9591 130.015C77.9591 133.318 80.6334 136 83.9377 136H177.326C180.626 136 183.305 133.323 183.305 130.015V83.2743C183.305 81.6865 182.675 80.1648 181.556 79.0445"
        />
        <Squiggle d={animationPath} stroke="#DDF33F" strokeWidth="11.8261" strokeLinejoin="bevel" />
        <Ball r="6" fill="#1CCBD7" />
      </svg>
    </Item>
  );

  const fullPageLayout = (
    <Container fullPageBackgroundColour={fullPageBackgroundColour}>
      <InnerContainer>{animatedLogo}</InnerContainer>
    </Container>
  );

  return fullPage ? fullPageLayout : animatedLogo;
};

export default AnimatedLogo;
